import { useMantineTheme } from '@mantine/core';
import { useDisclosure, useMediaQuery } from '@mantine/hooks';
import dynamic from 'next/dynamic';
import Head from 'next/head';
import { useRouter } from 'next/router';
import RatingComponent from '../rating';

import VendorHeader from './components/vendorHeader';
import VendorMenu from './components/vendorMenu';
import { HomePageProps } from './types';

const CartAffix = dynamic(() => import('./components/cartAffix'), { ssr: false });

type Props = HomePageProps;

const HomeScreen = (props: Props) => {
  const { vendor } = props;

  const router = useRouter();
  const { ratingOrderId } = router.query;
  const [opened, { close }] = useDisclosure(true);

  const theme = useMantineTheme();
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.xs})`);

  return (
    <>
      <Head>
        <title>{vendor?.name}</title>
      </Head>
      <VendorHeader vendor={vendor} />
      <VendorMenu vendor={vendor} isMobile={isMobile} />
      <CartAffix minimumBasket={vendor?.minimumBasket} isQuickOrder={!!vendor?.isQuickOrder} />

      <RatingComponent
        home={{ vendor }}
        modal={{
          onClose: () => close(),
          fullScreen: isMobile,
          opened: opened && Boolean(ratingOrderId),
          centered: true,
        }}
      />

      {/* {vendor?.showPaymentModal ? <SalonOrderModal vendorId={safeString(vendor?.id)} /> : null} */}
      {/* {[
        '09b800a4-9239-4eef-9d45-5a722947dc91',
        '90d2d14d-1472-4437-9a87-bcf845772480',
        '8c028c67-6f84-4597-8d8f-3315c5dd9af0',
      ].includes(vendor?.id || '') ? (
        <DiscountModal />
      ) : null} */}
    </>
  );
};

export default HomeScreen;
